define('core/filters/i18nFilter',[
    'angular',
    'core/services/I18nService'
], function (angular) {
    'use strict';
    angular.module('dnaApp').filter('i18n', ['I18nService', '$filter', function (I18nService, $filter) {
        /**
         * Arguments passed into the i18n filter with the prefix 'i18n_' are meant to be be looked up in the properties
         * file. This method is called for each element in the args array that was passed to the i18n filter. Any element
         * found with the prefix will be looked up using I18nService.get() and that value will be replaced in the args
         * array.
         * @param element The element in the args array. If it begins with 'i18n_' it will be considered as a key in the properties file.
         * @param index The current index into the args array.
         * @param array The actual args array.
         */
        function getProperty(index, element, array) {
            // Determine if the element is a properties file key that needs to be looked up. Property keys never end
            // with a period.
            if (typeof element === 'string' && element[element.length - 1] !== '.' && element.substring(0, 5) === 'i18n_') {
                array[index] = I18nService.get(element.substring(5, element.length));
            }
        }

        function i18nFilter(key, args, filters) {
            var i, data, split;
            if (arguments.length > 1) {
                if (args instanceof Array) {
                    for (i = 0; i < args.length; i++) {
                        getProperty(i, args[i], args);
                    }
                    if (filters && filters instanceof Array) {
                        data = [];
                        for (i = 0; i < args.length; i++) {
                            if (filters[i]) {
                                split = filters[i].indexOf(':');
                                if (split !== -1) {
                                    data.push($filter(filters[i].substring(0, split))(args[i], filters[i].substring(split + 1)));
                                } else {
                                    data.push($filter(filters[i])(args[i]));
                                }
                            } else {
                                data.push(args[i]);
                            }
                        }
                        return I18nService.get(key, data);
                    }

                    return I18nService.get(key, args);
                }
                return key;
            }
            return I18nService.get(key);
        }

        i18nFilter.$stateful = true;

        return i18nFilter;
    }]);
});

